// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stock.stockpickinglist', {
        url: "/stockpickinglist",
        views: {
            'articleView@stock': {
                templateUrl: 'main/stock/pickinglist/stockPickingList.tpl.html',
                controller: 'StockPickingListController as vm'
            }
        },
        resolve: {
            locations: locationResolver
        }
    });
}

// @ngInject
function locationResolver(AnalysisApiService) {
    return AnalysisApiService.getLocations();
}

// @ngInject
function StockPickingListController($window, $translate, $scope, loadSpinnerService, StockApiService, ToasterService, locations) {
    var vm = this;

    //Properties
    vm.startDate = new Date();
    vm.endDate = new Date();
    vm.location = undefined;
    vm.locations = locations;
    vm.sortorders = [];
    vm.sortOrder2 = undefined;
    vm.sortOrder3 = undefined;
    vm.showCollection = false;
    vm.showDepartment = false;
    vm.selectedGrouping = {};
    vm.includeArticleNumber = false;
    vm.includeStorageItems = false;
    vm.includeIsPhotographed = false;
    vm.includeZeroAndNegativeQuantity = false;
    vm.showRestOfLocations = false;

    vm.portraitOrientation = false;
    vm.groupings = [];

    //Methods
    vm.getStockPickingList = getStockPickingList;
    vm.canPrintStockPickingList = canPrintStockPickingList;

    activate();

    function activate() {
        vm.startDate.setDate(vm.startDate.getDate() - 1);
        vm.startDate.setHours(0);
        vm.startDate.setMinutes(0);
        vm.sortorders = [
            { id: 1, description: $translate.instant('article.brand'), code: 'Brand' }, //'Varumärke'
            { id: 2, description: $translate.instant('article.maingroup'), code: 'MainGroup' }, //'Huvudgrupp'
            { id: 3, description: $translate.instant('article.articlename'), code: 'ArticleName' }, //'Produktnamn'
            { id: 4, description: $translate.instant('article.articlenumber'), code: 'ArticleNumber' }, //'Produktnummer'
            { id: 5, description: $translate.instant('article.alternativearticlenumber'), code: 'AlternativeArticleNumber' }, //'Lev. produktnummer'
            { id: 6, description: $translate.instant('article.department'), code: 'Department' }, //'Avdelning'
            { id: 7, description: $translate.instant('common.variant1s'), code: 'Variant1Name' }, //'Variant 1 (färg)'
            { id: 8, description: $translate.instant('common.variant2s'), code: 'Variant2Name' }, //'Variant 2 (storlek)'
            { id: 9, description: $translate.instant('article.storageLocation'), code: 'StorageLocation' } //'Lagerplats'
        ];
        vm.sortOrder1 = vm.sortorders[0];
        vm.groupings = [
            { id: 1, name: $translate.instant('stock.print.noGrouping'), value: 'none' }, //'Ingen'
            { id: 2, name: $translate.instant('stock.print.groupOnCollection'), value: 'groupOnCollection' }, //'Gruppera på säsong'
            { id: 3, name: $translate.instant('stock.print.groupOnDepartment'), value: 'groupOnDepartment' }, //'Gruppera på avdelning'
            { id: 4, name: $translate.instant('stock.print.groupOnCollectionAndSubcategory'), value: 'groupOnCollectionAndSubcategory' }, //'Gruppera på säsong och produktkategori'
            { id: 5, name: $translate.instant('stock.print.groupOnDepartmentAndSubcategory'), value: 'groupOnDepartmentAndSubcategory' } //'Gruppera på avdelning och produktkategori'
        ];
        vm.selectedGrouping = vm.groupings[0];
        readSettingsFromLocalStorage();

        $scope.$watch(function() { return vm.portraitOrientation; }, function(oldValue, newValue) {
            if (oldValue !== newValue) {
                vm.showCollection = false;
                vm.showDepartment = false;
                vm.includeArticleNumber = false;
                vm.includeStorageItems = false;
                vm.includeIsPhotographed = false;
                vm.includeZeroAndNegativeQuantity = false;
                vm.showRestOfLocations = false;

            }
        });
    }

    function getStockPickingList() {
        loadSpinnerService.start('mainSpinner');

        saveSettingsToLocalStorage();

        var request = {
            startDate: vm.startDate,
            endDate: vm.endDate,
            locationId: vm.location.id,
            sortOrder1: vm.sortOrder1.code,
            sortOrder2: vm.sortOrder2 ? vm.sortOrder2.code : undefined,
            sortOrder3: vm.sortOrder3 ? vm.sortOrder3.code : undefined,
            showCollection: vm.showCollection,
            showDepartment: vm.showDepartment,
            grouping: vm.selectedGrouping.value,
            includeArticleNumber: vm.includeArticleNumber,
            includeStorageItems: vm.includeStorageItems,
            includeIsPhotographed: vm.includeIsPhotographed,
            includeZeroAndNegativeQuantity: vm.includeZeroAndNegativeQuantity,
            portraitOrientation: vm.portraitOrientation,
            showRestOfLocations: vm.showRestOfLocations
        };

        StockApiService.downloadStockPickingList(request).then(function(response) {
            if (response && response.status === 204) {
                ToasterService.showWarning(
                    $translate.instant('pickinglist.timespan') + ' ' + formatDate(vm.startDate) + ' - ' + formatDate(vm.endDate) + ' ' + $translate.instant('common.noResults'),
                    $translate.instant('stock.stockpickinglist')
                );
            }
        }, function(error) {
            console.log(error);
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function formatDate(date) {
        if (!date) { return ''; }
        return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0') + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0');
    }

    function canPrintStockPickingList() {
        return !vm.location || vm.location.id <= 0;
    }

    function saveSettingsToLocalStorage() {
        var request = {
            sortOrder1: angular.copy(vm.sortOrder1.code),
            sortOrder2: vm.sortOrder2 ? angular.copy(vm.sortOrder2.code) : null,
            sortOrder3: vm.sortOrder3 ? angular.copy(vm.sortOrder3.code) : null,
            showCollection: vm.showCollection,
            showDepartment: vm.showDepartment,
            grouping: vm.selectedGrouping.value,
            includeArticleNumber: vm.includeArticleNumber,
            includeStorageItems: vm.includeStorageItems,
            includeIsPhotographed: vm.includeIsPhotographed,
            includeZeroAndNegativeQuantity: vm.includeZeroAndNegativeQuantity,
            portraitOrientation: vm.portraitOrientation,
            showRestOfLocations: vm.showRestOfLocations
        };

        $window.localStorage.setItem('printStockPickingListSettings', JSON.stringify(request));
    }

    function readSettingsFromLocalStorage() {
        if ($window.localStorage.printStockPickingListSettings) {
            if (!isJsonString($window.localStorage.getItem('printStockPickingListSettings'))) {
                $window.localStorage.removeItem('printStockPickingListSettings');
            }

            var settingsStr = $window.localStorage.getItem('printStockPickingListSettings');
            if (settingsStr !== null) {
                var json = JSON.parse(settingsStr);
                if (json.portraitOrientation) { vm.portraitOrientation = json.portraitOrientation; }
                if (json.showCollection) { vm.showCollection = json.showCollection; }
                if (json.showDepartment) { vm.showDepartment = json.showDepartment; }
                if (json.grouping) { vm.selectedGrouping = _.find(vm.groupings, function (o) { return o.value === json.grouping; }); }
                if (json.includeArticleNumber) { vm.includeArticleNumber = json.includeArticleNumber; }
                if (json.includeStorageItems) { vm.includeStorageItems = json.includeStorageItems; }
                if (json.includeIsPhotographed) { vm.includeIsPhotographed = json.includeIsPhotographed; }
                if (json.includeZeroAndNegativeQuantity) { vm.includeZeroAndNegativeQuantity = json.includeZeroAndNegativeQuantity; }
                if (json.showRestOfLocations) { vm.showRestOfLocations = json.showRestOfLocations; }
                if (json.sortOrder1 && _.indexOf(vm.sortorders, function(so) { return so.code === json.sortOrder1; })) { vm.sortOrder1 = _.find(vm.sortorders, function(so) { return so.code === json.sortOrder1; }); }
                if (json.sortOrder2 && _.indexOf(vm.sortorders, function(so) { return so.code === json.sortOrder2; })) { vm.sortOrder2 = _.find(vm.sortorders, function(so) { return so.code === json.sortOrder2; }); }
                if (json.sortOrder3 && _.indexOf(vm.sortorders, function(so) { return so.code === json.sortOrder3; })) { vm.sortOrder3 = _.find(vm.sortorders, function(so) { return so.code === json.sortOrder3; }); }
            }
        }
    }
    function isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
}

angular.module('stock.stockpickinglist', [])
    .config(stateConfig)
    .controller('StockPickingListController', StockPickingListController);
